import React from 'react'
import cls from 'classnames'
import styles from './style.module.less'
const dpr = window.devicePixelRatio

export default ({ selected, value, onSelect }) => {
  const check = item =>
    selected?.some(e => {
      if (e?.id && item?.id) {
        return e?.id === item?.id
      } else if (e?.uid && item?.uid) {
        return e?.uid === item?.uid
      } else {
        return e?.url === item?.url
      }
    })

  return (
    <div className={styles.selectList}>
      {value?.map((e, index) => (
        <div
          key={e?.uid || index}
          className={cls({
            item: true,
            checked: check(e)
          })}
          onClick={() => onSelect(e, check(e))}
          style={{
            backgroundImage: `url("${e?.url}?imageView2/2/w/${Math.round(
              120 * dpr
            )}/h/${Math.round(120 * dpr)}")`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          }}
        />
      ))}
    </div>
  )
}
